// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"722":"notFound","945":"dashboard"}[chunkId] + "." + {"722":"8285cd24","945":"b5b7f9f1"}[chunkId] + ".js";
};